<template>
  <div class="typing-indicator" aria-label="Escribiendo">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<style scoped>
.typing-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  border-radius: 12px;
  background: #f1f1f1;
}

.dark .typing-indicator {
  background: var(--p-primary-900);
}

.typing-indicator span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #8a8a8a;
  animation: typing-wave 1.2s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.15s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes typing-wave {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }

  30% {
    transform: translateY(-3px);
    opacity: 1;
  }
}
</style>
